import { render, staticRenderFns } from "./CompView.vue?vue&type=template&id=3a283752&scoped=true"
import script from "./CompView.vue?vue&type=script&lang=js"
export * from "./CompView.vue?vue&type=script&lang=js"
import style0 from "./CompView.vue?vue&type=style&index=0&id=3a283752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a283752",
  null
  
)

export default component.exports